import { ArrowDown, UserPlus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PodcastPromo } from "@/components/PodcastPromo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="pt-32 md:pt-36 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <p data-testid="hero-overline" className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Daniel Pekař | Finanční poradenství
          </p>
          <h1 className="font-display text-5xl md:text-6xl lg:text-[4.25rem] tracking-tight leading-[1.08] text-[#252525] mt-8">
            Finance,<br />kterým <span className="italic text-[#B69A58]">rozumíte</span>.
          </h1>
          <p data-testid="hero-subtitle" className="text-base md:text-lg text-[#4A4A4A] leading-relaxed mt-8 max-w-xl">
            Pomohu vám s hypotékou, úvěrem, investicemi i pojištěním. Zorientujete se v možnostech
            a vyberete řešení podle vaší životní situace — srozumitelně, osobně a bez zbytečných složitostí.
          </p>
          <div className="mt-10">
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 sm:gap-6">
              <a
                href="#kontakt"
                data-testid="hero-primary-cta"
                className="border border-[#B69A58] bg-white text-[#252525] hover:bg-[#B69A58] hover:text-white transition-colors duration-300 px-8 py-4 text-sm uppercase tracking-widest font-medium whitespace-normal lg:whitespace-nowrap text-center"
              >
                Domluvit nezávaznou konzultaci
              </a>
              <a
                href={`${API}/vizitka.vcf`}
                download="Daniel-Pekar.vcf"
                data-testid="hero-save-contact"
                className="inline-flex items-center justify-center gap-2.5 border border-[#B69A58] text-[#B69A58] hover:bg-[#B69A58] hover:text-white transition-colors duration-300 px-8 py-4 text-sm uppercase tracking-widest font-medium whitespace-nowrap text-center"
              >
                <UserPlus className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
                Uložit kontakt
              </a>
            </div>
            <a
              href="#pojisteni"
              data-testid="hero-secondary-link"
              className="group inline-flex items-center gap-2 mt-8 text-sm text-[#252525] border-b border-[#B69A58] pb-1 hover:text-[#B69A58] transition-colors duration-300"
            >
              S čím vám mohu pomoci
              <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" strokeWidth={1.5} />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="flex justify-center lg:justify-end">
          <div className="relative">
            <img
              src="/images/daniel-pekar-hero.webp"
              alt="Daniel Pekař — finanční poradce"
              width={1000}
              height={1151}
              loading="eager"
              fetchPriority="high"
              data-testid="hero-portrait"
              className="w-full max-w-md h-auto block rounded-tl-[96px] md:rounded-tl-[140px] rounded-tr-2xl rounded-br-2xl rounded-bl-2xl"
            />
            <PodcastPromo />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
